import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Popover, PopoverBody } from 'reactstrap';
import * as Actions from '../../actions/schoolEntryActions';

class View extends PureComponent {
  componentDidMount() {
    this.props.openPopOver();
  }

  render() {
    const target = document.getElementById('login-button');
    if (target === null) {
      return null;
    }
    return (
      <Popover trigger="legacy" isOpen={this.props.popoverOpen} placement="bottom" target={target} fade>
        <PopoverBody>
          過去にキャンプ・スクールに
          <br />
          参加された方は
          <br />
          先にログインして下さい
        </PopoverBody>
      </Popover>
    );
  }
}

View.propTypes = {
  popoverOpen: PropTypes.bool.isRequired,
  openPopOver: PropTypes.func.isRequired,
};

export default connect((state) => ({
  popoverOpen: state.schoolEntry.popoverOpen,
}), (dispatch) => ({
  openPopOver: (payload) => dispatch({
    type: Actions.SAGA_OPEN_POP_OVER,
    payload,
  }),
}))(View);
